import { NgModule, Optional, SkipSelf, ModuleWithProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OAuthInterceptor } from './oauth-interceptor';

@NgModule({})
export class OAuthInterceptorModule {
    public constructor(@Optional() @SkipSelf() parentModule: OAuthInterceptorModule) {
        if (parentModule) {
            throw new Error('❌ CoreModule is already loaded. Import it only in AppModule.');
        }
    }

    public static forRoot(): ModuleWithProviders<OAuthInterceptorModule> {
        return {
            ngModule: OAuthInterceptorModule,
            providers: [
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: OAuthInterceptor,
                    multi: true,
                },
            ],
        };
    }
}
